export const KEYS = { ENTER: 13, TAB: 9 };
